document.addEventListener("DOMContentLoaded", function() {
  $(document).ready(function(){
    $('.video-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      nextArrow: '<button class="m-slider-controls__button m-slider-controls__button-next slick-button-next" aria-label="Next"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      prevArrow: '<button class="m-slider-controls__button m-slider-controls__button-prev slick-button-prev" aria-label="Previous"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1442,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  });
});

// // Get modal elements
// const modal = document.getElementById("customFormModal");
// const triggerButton = document.querySelector(".form-wrapper a.m-button.m-button--primary");
// const closeBtn = document.querySelector(".close");

// // Open modal when the anchor button is clicked
// if (triggerButton) {
//   triggerButton.addEventListener("click", function(event) {
//     event.preventDefault(); // Prevent default anchor action
//     modal.style.display = "block";
//   });
// }

// // Close modal when (X) button is clicked
// if (closeBtn) {
//   closeBtn.addEventListener("click", function() {
//     modal.style.display = "none";
//   });
// }

// // Close modal when clicking outside the form
// window.addEventListener("click", function(event) {
//   if (event.target === modal) {
//     modal.style.display = "none";
//   }
// });



// const modal = document.getElementById("customFormModal");
// const triggerButtons = document.querySelectorAll(".form-wrapper a.m-button.m-button--primary"); // Select all buttons
// const closeBtn = document.querySelector(".close");

// // Function to open modal
// function openModal() {
//   modal.style.display = "block";
//   document.body.classList.add("modal-open"); // Disable body scroll
// }

// // Function to close modal
// function closeModal() {
//   modal.style.display = "none";
//   document.body.classList.remove("modal-open"); // Enable body scroll
// }

// // Add event listener to all trigger buttons
// triggerButtons.forEach(button => {
//   button.addEventListener("click", function(event) {
//     event.preventDefault();
//     openModal();
//   });
// });

// // Close modal when (X) button is clicked
// if (closeBtn) {
//   closeBtn.addEventListener("click", closeModal);
// }

// // Close modal when clicking outside
// window.addEventListener("click", function(event) {
//   if (event.target === modal) {
//     closeModal();
//   }
// });


 document.addEventListener("DOMContentLoaded", function () {
    // Check if the current page is "create-your-own"
    if (window.location.pathname === "/pages/create-your-own" && window.location.href.includes("contact_posted=true")) {
      // Remove query params after form submission
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  });
